import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../AuthContext';
import axiosInstance from '../axiosInstance';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    usertype: 1,
    created_by: 1
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [userTypes, setUserTypes] = useState([]);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserTypes = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const response = await axiosInstance.get('/usertypes', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        setUserTypes(response.data.usertypes);
      } catch (error) {
        setUserTypes([
          { id: 1, name: 'superadmin', description: 'Super Administrator', permissions: ['all'] },
          { id: 2, name: 'admin', description: 'Administrator', permissions: ['all'] },
          { id: 3, name: 'manager', description: 'Manager', permissions: ['billing', 'dashboard'] },
          { id: 4, name: 'cashier', description: 'Cashier', permissions: ['billing'] },
          { id: 5, name: 'finance', description: 'Finance', permissions: ['finance'] },
          { id: 6, name: 'sales', description: 'Sales', permissions: ['sales'] },
          { id: 7, name: 'user', description: 'Basic User', permissions: ['dashboard'] },
        ]);
      }
    };
    fetchUserTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Invalid email';
    if (!formData.password) newErrors.password = 'Password is required';
    else if (formData.password.length < 8) newErrors.password = 'Minimum 8 characters';
    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      const token = localStorage.getItem('access_token');
      let apiUrl = 'https://apiemiride.socialpartners.in/api/auth/register';
      let requestData = {
        name: formData.name,
        email: formData.email,
        password: formData.password
      };
      let headers = { 'Content-Type': 'application/json' };
      if (token) {
        apiUrl = 'https://apiemiride.socialpartners.in/api/register';
        requestData = {
          ...requestData,
          phone: formData.phone,
          usertype: parseInt(formData.usertype)
        };
        headers.Authorization = `Bearer ${token}`;
      }
      await axiosInstance.post(apiUrl, requestData, { headers });
      setMessage('User registered successfully!');
      setFormData({
        name: '', email: '', phone: '', password: '', confirmPassword: '', usertype: 1, created_by: 1
      });
      if (!token) setTimeout(() => navigate('/login'), 2000);
    } catch (error) {
      if (error.response) setMessage(error.response.data.error || 'Registration failed');
      else setMessage('Network or unknown error');
    } finally {
      setLoading(false);
    }
  };

  const selectedUserType = userTypes.find(type => type.id === parseInt(formData.usertype));
  const isAdminMode = localStorage.getItem('access_token');

  return (
    <div className="container mt-5">
      <div className="card card-primary">
        <div className="card-header">
          <h3 className="card-title">{isAdminMode ? 'Register New User' : 'Register'}</h3>
        </div>
        <form onSubmit={handleSubmit} className="p-3">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Name</label>
                <input name="name" value={formData.name} onChange={handleChange} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
              </div>
            </div>
          </div>

          {isAdminMode && (
            <div className="form-group">
              <label>Phone</label>
              <input name="phone" value={formData.phone} onChange={handleChange} className="form-control" />
            </div>
          )}

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Password</label>
                <input type="password" name="password" value={formData.password} onChange={handleChange} className={`form-control ${errors.password ? 'is-invalid' : ''}`} />
                {errors.password && <div className="invalid-feedback">{errors.password}</div>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Confirm Password</label>
                <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`} />
                {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
              </div>
            </div>
          </div>

          {isAdminMode && (
            <div className="form-group">
              <label>User Type</label>
              <select name="usertype" value={formData.usertype} onChange={handleChange} className="form-control">
                {userTypes.map(type => (
                  <option key={type.id} value={type.id}>{type.name} - {type.description}</option>
                ))}
              </select>
            </div>
          )}

          {message && (
            <div className={`alert ${message.includes('successfully') ? 'alert-success' : 'alert-danger'}`}>{message}</div>
          )}

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Registering...' : (isAdminMode ? 'Create User' : 'Register')}
          </button>

          {!isAdminMode && (
            <p className="mt-3">Already have an account? <span className="text-primary" style={{ cursor: 'pointer' }} onClick={() => navigate('/login')}>Login here</span></p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Register;